import { ReactElement } from 'react';
import { TextField } from '@ff-it/form';
import { AllActivityTypesField } from 'components';
import { TicketForm } from './TicketForm';
import { CompanyField } from 'modules/core/company/components';

const initialValues = {
  company: null,
  name: '',
  service: '',
  activity_type: null,
  extra_info: '',
};

export function NewOutletOrServiceCategory(): ReactElement {
  return (
    <TicketForm
      title="New outlet or service category"
      url="support/tickets/new_outlet_or_service_category/"
      initialValues={initialValues}
    >
      <div className="form-row">
        <CompanyField name="company" label="Provider" className="col-md-6" required includeBranches={false} />
      </div>
      <div className="form-row border-top pt-3">
        <TextField name="name" label="Outlet or service category name" className="col-md-6" required />
      </div>
      <div className="form-row">
        <TextField name="service" label="Service" className="col-md-6" help="Describe the service" required multiline />
        <AllActivityTypesField name="activity_type" label="Type" className="col-md-2" required />
      </div>
      <div className="form-row">
        <TextField name="extra_info" label="Extra info" help="Any other info to know" className="col-6" multiline />
      </div>
    </TicketForm>
  );
}
